import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b36dd36"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "CookiesMainView"
}
const _hoisted_2 = { class: "BigPlaceholder P-Rel" }
const _hoisted_3 = {
  class: "BigContainer",
  style: {"background":"none","filter":"none"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_6 = ["CardComponent", "index"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_8 = { class: "W-100 D-Flex FlexCenter Shadow1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainPageDateSelector = _resolveComponent("MainPageDateSelector")!
  const _component_CookiesDashCard = _resolveComponent("CookiesDashCard")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_AdminUIPanel = _resolveComponent("AdminUIPanel")!
  const _component_CookiesCardsSizesStyle = _resolveComponent("CookiesCardsSizesStyle")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.Access('DashBoard_View'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _createVNode(_component_MainPageDateSelector),
              _createElementVNode("div", {
                id: "CookiesCardsOrganizer",
                class: _normalizeClass(["D-Flex FlexWrap P-Rel", _ctx.$store.state.CookiesMemory.DashCardOnhold ? 'NoUserSelect' : '']),
                style: {"gap":"1em"}
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ComputedCards, (card, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: (card.Data),
                    CardComponent: card.Data.CardComponent,
                    style: _normalizeStyle({
            width: card.Settings.FixedSize ? `min(85vw,${card.Settings.FixedSize}px)` : '',
            maxWidth: card.Settings.FixedSize ? `min(85vw,${card.Settings.FixedSize}px)` : '',
            minWidth: card.Settings.FixedSize ? `min(85vw,${card.Settings.FixedSize}px)` : ''
          }),
                    index: index,
                    class: _normalizeClass(["CookiesCardSize CookiesCardPlaceHolder", [ 'DashCardSize' + card.Settings.Size, (_ctx.EditingCard !== -1 && _ctx.EditingCard !== index) ? 'Disabled' : '']]),
                    onMousemove: _cache[2] || (_cache[2] = ($event: any) => (_ctx.CardIsDragging ? _ctx.MousePlace() : null))
                  }, [
                    _createVNode(_component_CookiesDashCard, {
                      Loading: _ctx.Loading,
                      CookiesData: card.Data,
                      CookiesSettings: card.Settings,
                      onIamDragging: _cache[0] || (_cache[0] = ($event: any) => (_ctx.MyCardIsDragging())),
                      onDraggingStopped: _cache[1] || (_cache[1] = ($event: any) => (_ctx.DraggingStopped())),
                      onSettings: ($event: any) => (_ctx.OpenCardSettings(index, card)),
                      class: _normalizeClass('DashCardSize' + card.Settings.Size),
                      FixedStyle: {
              width: card.Settings.FixedSize ? `min(85vw,${card.Settings.FixedSize}px)` : undefined,
              maxWidth: card.Settings.FixedSize ? `min(85vw,${card.Settings.FixedSize}px)` : undefined,
              minWidth: card.Settings.FixedSize ? `min(85vw,${card.Settings.FixedSize}px)` : undefined
            }
                    }, null, 8, ["Loading", "CookiesData", "CookiesSettings", "onSettings", "class", "FixedStyle"])
                  ], 46, _hoisted_6))
                }), 128))
              ], 2),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_CookiesIcon, {
                  class: "SQR2_5em F1em HoverGlow O-25",
                  ID: 'Add',
                  Color: { ColorMain: _ctx.Theme.Shade4, ColorSecond: _ctx.Theme.Shade0 }
                }, null, 8, ["Color"])
              ]),
              _hoisted_9,
              _hoisted_10
            ])
          ]),
          (_ctx.EditingCard > -1)
            ? (_openBlock(), _createBlock(_component_AdminUIPanel, {
                key: 0,
                FooterButtons: ['save'],
                onSave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.SaveCards())),
                onReset: _cache[4] || (_cache[4] = ($event: any) => (_ctx.ResetCard())),
                CookiesSettings: _ctx.AdminPanelSettings
              }, null, 8, ["CookiesSettings"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_CookiesCardsSizesStyle)
  ], 64))
}